import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {CustomSelect} from '../../../common/components/StyledComp';
import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import {useQuery} from '@apollo/react-hooks';
import {PulseLoader} from 'react-spinners';
import Error from '../../../common/components/Error/Error';


const GRAPHQL_QUERY_BILLING_SUBSCRIPTION_PLANS = gql`
  query billingSubscriptionPlans($criteria: CriteriaListInput, $additionalCriteria: BillingSubscriptionPlansCriteriaListInput) {
    billingSubscriptionPlans(criteria: $criteria, additionalCriteria: $additionalCriteria) {
      rows {
        id
        amount
        billingScheme
        currency
        interval
        intervalCount
        nickname
        position
      }
      hasMore
      id
    }
  }
`;

const SelectSubscriptionPlan = ({t, onChange, value, allowNull, ...props}) => {

  const {data, loading, error} = useQuery(GRAPHQL_QUERY_BILLING_SUBSCRIPTION_PLANS);

  if (loading) {
    return <PulseLoader loading={true}/>;
  }
  if (error) {
    console.error(error);
    return <Error error={t('noPlanError')}/>;
  }
  else {
    const types = data.billingSubscriptionPlans.rows.map(function(value, index) {
      return <option value={value.id} key={index}>{value.nickname}</option>;
    });

    return (
      <CustomSelect
        name="plans"
        onChange={onChange}
        value={value}
        absolute
        {...props}>
        <option disabled value="default">
          {t('plans.title')}
        </option>
        {allowNull && <option value="all">{t('plans.all')}</option>}
        {types}
      </CustomSelect>
    );
  }

};

SelectSubscriptionPlan.defaultProps = {
  allowNull: false,
};

SelectSubscriptionPlan.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  allowNull: PropTypes.bool,
};

export default compose(
  withTranslation('billing'),
)(SelectSubscriptionPlan);
